import { DefaultRootState, InboxBrandState } from 'react-redux';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { InboxBrandResponse } from '@idk-web/api';

const initialState: InboxBrandState = {
  name: null,
  companyName: null,
  logoUrl: null,
  backgroundImage: null,
  primaryAccentColor: null,
  secondaryAccentColor: null,
  font: null,
  defaultLanguage: null,
  providers: [],
  languages: [],
};

export const inboxBrandSlice = createSlice({
  name: 'inbox/brand',
  initialState: initialState as InboxBrandState,
  reducers: {
    updateBrand(
      state,
      action: PayloadAction<InboxBrandResponse>,
    ): InboxBrandState {
      return action.payload;
    },
    resetBrand(): InboxBrandState {
      return initialState;
    },
  },
});

export const { updateBrand, resetBrand } = inboxBrandSlice.actions;

export const selectInboxBrand = (state: DefaultRootState) => state.inboxBrand;

export default inboxBrandSlice.reducer;
